import { useState } from "react";
import { ExerciseFolders } from "../../components/ExercisesTable/ExerciseFolders";
import { SpecialCategoriesManager } from "../../components/ExercisesTable/SpecialCategoriesManager";
import { CheckExercisesSection } from "../../components/ExercisesTable/CheckExercisesSection";
import { Skeleton } from "../../components/Skeleton";
import {
  useGetAllExercisesQuery,
  useGetAllExerciseContainersQuery,
} from "../../libs/exercises/api";

export default function Exercises() {
  const { data: exercises, isLoading, error } = useGetAllExercisesQuery();
  const { data: containers, isLoading: containersLoading } =
    useGetAllExerciseContainersQuery();
  const [activeTab, setActiveTab] = useState<"exercises" | "check" | "categories">("exercises");

  if (isLoading || containersLoading) {
    return <Skeleton />;
  }
  if (error) {
    return <div>Error...</div>;
  }

  const tabs = [
    { key: "exercises" as const, label: "Esercizi" },
    { key: "check" as const, label: "Check" },
    { key: "categories" as const, label: "Categorie Speciali" },
  ];

  return (
    <div>
      {/* Tab bar */}
      <div className="flex border-b border-gray-200 dark:border-gray-700 mb-4">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === tab.key
                ? "border-blue-500 text-blue-600 dark:text-blue-400"
                : "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      {activeTab === "exercises" && (
        <ExerciseFolders exercises={exercises ?? []} containers={containers ?? []} />
      )}
      {activeTab === "check" && <CheckExercisesSection exercises={exercises} />}
      {activeTab === "categories" && <SpecialCategoriesManager />}
    </div>
  );
}
